import { TestResult } from "@design-controls/types";

export const TestResultVariantColour: Record<
  TestResult["result"],
  "green" | "red" | "gray"
> = {
  passed: "green",
  failed: "red",
  blocked: "gray",
};

export const ResultValueToLabel: Record<string, string> = {
  passed: "Passed",
  failed: "Failed",
  blocked: "Blocked",
};
